
















import Vue from 'vue'
import { Announcement, StandardAnnouncement, AnnouncementType } from '@/common/types/announcements'
import { getJsonData } from '@/common/utils/dom'
import { mappingAnnouncementsData, mappingNotificationsData } from '@/common/utils/common'

const MIDORI_ANNOUNCEMENT_ID = 23
const MIDORI_BRAND_NAME = 'midori-anzen'

export default Vue.extend({
  props: {
    currentBrandName: {
      type: String,
      default: ''
    }
  },
  data(): {
    announcements: StandardAnnouncement[]
  } {
    return {
      announcements: []
    }
  },
  computed: {
    isTopPage(): boolean {
      return window.location.pathname === '/'
    }
  },
  created() {
    let announcements = [] as StandardAnnouncement[]
    const announcementsData = getJsonData('#json-announcements')
    if (announcementsData) {
      // Do not display info announcement in this component on top page
      if (this.isTopPage) {
        announcements = mappingAnnouncementsData(announcementsData).filter(
          announcement => announcement.announcementType !== AnnouncementType.INFO
        )
      } else {
        // Temporary announcement display for Midori Anzen brand
        announcements = this.currentBrandName === MIDORI_BRAND_NAME
          ? mappingAnnouncementsData(announcementsData)
          : mappingAnnouncementsData(announcementsData).filter(
            announcement => announcement.id !== MIDORI_ANNOUNCEMENT_ID
          )
      }
    }
    const notificationsData = getJsonData('#json-notifications')
    if (notificationsData) {
      announcements = [
        ...announcements,
        ...mappingNotificationsData(notificationsData)
      ]
    }
    this.announcements = [
      ...announcements.filter(item => item.announcementType === AnnouncementType.EMERGENCY),
      ...announcements.filter(item => item.announcementType === AnnouncementType.ALERT),
      ...announcements.filter(item => item.announcementType === AnnouncementType.INFO)
    ]
  },
  methods: {
    cssClassSelector(announcementType: string): string {
      return `sw-Flash_MessageBox-${announcementType}`
    },
    getContent(announcement: Announcement): string {
      const content = announcement.content
      if (!announcement.url) return content
      let linkTag = `
        <a
          href="${announcement.url}"
          target="${announcement.displayMethod}"
          rel="noopener" class="%className%">%content%</a>`
      const innerLink = (content.match(/\_.+\_/) || [])[0]
      if (innerLink) {
        linkTag = linkTag
          .replace('%className%', 'sw-Flash_MessageBox_TextLink')
          .replace('%content%', innerLink.replaceAll('_', ''))
        return content.replace(innerLink, linkTag)
      } else {
        linkTag = linkTag
          .replace('%className%', '')
          .replace('%content%', content)
        return linkTag
      }
    }
  }
})
